// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"back-home-button_wrapper__D5RcY","container":"back-home-button_container__sfumw","back_icon":"back-home-button_back_icon__79Pcw","text":"back-home-button_text__3Y_SD"};